import { Outlet } from 'react-router-dom';
import { useAuth } from '~services/auth';

export default function ProtectedRoute() {
  const { status } = useAuth();

  if (status === 'undetermined') {
    return null;
  }

  return status === 'authenticated' || status === 'logging-out' ? (
    <Outlet />
  ) : (
    // TODO: redirect to Keycloak login
    <></>
    // <Navigate to={'/login'} replace={true} />
  );
}
